module.exports = __webpack_public_path__ + "img/almacen.f6a0f72d.svg";